class AssetManagementModeTypes {
	static Edit = 0;
	static NewAsset = 1;
}

export default AssetManagementModeTypes;